import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackCustom } from '../lib/pixel';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/oeY7xTvjvoyXxe4s9vKeTP/ChatGPT_Image_15_jun_2026,_09_20_00.png';
const BENEFITS = [{
  icon: '📚',
  text: '6 Módulos Profesionales'
}, {
  icon: '🎁',
  text: '4 Bonos Exclusivos'
}, {
  icon: '📜',
  text: 'Certificado Digital'
}, {
  icon: '⚡',
  text: 'Acceso Inmediato'
}, {
  icon: '💻',
  text: '100% Digital'
}];
const SOCIAL_PROOF = [{
  icon: '🏆',
  text: 'Formación clara y organizada paso a paso'
}, {
  icon: '🔮',
  text: 'Interpretación astrológica desde cero'
}, {
  icon: '📥',
  text: 'Descarga inmediata'
}];
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-6 pb-8 md:pt-12 md:pb-14 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center bg-[#0a0e1f] border-b border-[#ffffff]/5" data-id="element-96">
      <div ref={ref1} className={`reveal container mx-auto max-w-2xl relative z-10 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-97">
        {/* Micro Headline */}
        <div className="mb-3 md:mb-4" data-id="element-98">
          <span className="text-[#d4af37] text-[9px] md:text-xs font-bold tracking-[0.2em] uppercase bg-[#1a1f3d] border border-[#d4af37]/30 rounded-full px-3.5 py-1.5 inline-flex items-center gap-1.5 shadow-sm" data-id="element-99">
            <span className="text-[#d4af37]" data-id="element-100">✨</span> FORMACIÓN PROFESIONAL EN
            ASTROLOGÍA
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif tracking-tight text-[#f5f1e6] text-[26px] sm:text-3xl md:text-4xl lg:text-5xl mb-2.5 md:mb-4 max-w-2xl mx-auto font-[800] leading-[1.12]" data-id="element-101">
          APRENDÉ ASTROLOGÍA PASO A PASO
        </h1>

        {/* Subheadline */}
        <p className="text-[#cbd0e0] mb-4 md:mb-6 leading-relaxed text-sm md:text-base max-w-xl mx-auto font-medium" data-id="element-102">
          Transformá tu interés por la astrología en una herramienta práctica
          para comprender cartas natales, descubrir talentos, interpretar
          patrones de vida y desarrollar una mirada profunda sobre vos mismo y
          los demás.
        </p>

        {/* Mockup */}
        <div className="flex justify-center mb-4 md:mb-6" data-id="element-103">
          <div className="relative w-full max-w-[320px] sm:max-w-[440px] md:max-w-[560px]" data-id="element-104">
            <div className="relative animate-float" data-id="element-105">
              <img src={PRODUCT_IMG} alt="MEGAPACK ASTROLOGÍA INTEGRAL" className="w-full object-contain block drop-shadow-[0_15px_30px_rgba(0,0,0,0.5)]" data-id="element-106" />
            </div>
          </div>
        </div>

        {/* Rating */}
        <div className="flex justify-center mb-4" data-id="element-107">
          <div className="flex items-center gap-2 bg-[#1a1f3d] border border-[#d4af37]/20 py-1.5 px-3.5 rounded-xl" data-id="element-108">
            <div className="flex gap-0.5 text-[#d4af37] text-sm" data-id="element-109">
              <span data-id="element-110">★</span>
              <span data-id="element-111">★</span>
              <span data-id="element-112">★</span>
              <span data-id="element-113">★</span>
              <span data-id="element-114">★</span>
            </div>
            <span className="text-[#f5f1e6] font-bold text-xs sm:text-sm" data-id="element-115">
              4.9/5
            </span>
            <span className="text-[#b8bdd4] text-xs sm:text-sm font-medium" data-id="element-116">
              · +800 alumnos de Argentina
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="mb-5" data-id="element-117">
          <a href="#pricing" onClick={() => trackCustom('ViewPricingIntent', {
          source: 'hero'
        })} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 rounded-xl text-[#0a0e1f] font-bold text-sm md:text-base tracking-widest uppercase transition-all shadow-[0_10px_25px_rgba(212,175,55,0.2)] hover:shadow-[0_15px_35px_rgba(212,175,55,0.3)] hover:-translate-y-1 bg-[#d4af37] hover:bg-[#c19b2e]" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-118">
            👉 QUIERO ACCEDER A LA FORMACIÓN
          </a>
          <p className="text-[#8b91ad] text-xs mt-2.5 font-bold" data-id="element-119">
            Acceso inmediato luego de completar tu compra.
          </p>
        </div>

        {/* Benefit chips */}
        <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5 mb-5 max-w-xl mx-auto" data-id="element-120">
          {BENEFITS.map((benefit, i) => <span key={i} className="inline-flex items-center gap-1 bg-[#1a1f3d] border border-[#d4af37]/20 rounded-full px-2.5 py-1 text-[#cbd0e0] text-[10px] sm:text-[11px] font-bold shadow-sm" data-id="element-121">
              <span className="leading-none" data-id="element-122">{benefit.icon}</span>
              {benefit.text}
            </span>)}
        </div>

        {/* Social Proof Bullets */}
        <div className="flex flex-col items-center gap-2 max-w-md mx-auto" data-id="element-123">
          {SOCIAL_PROOF.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-124">
              <span className="text-sm leading-none mt-0.5" data-id="element-125">{item.icon}</span>
              <span className="text-[#cbd0e0] text-xs sm:text-sm font-medium leading-snug" data-id="element-126">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}